/**
 * 扫描条码归一化：从扫码枪原始输出中提取系统运单号。
 *
 * 与后端 ThirdPartyLabelScanParser.kt 保持一致：
 * - USPS: 420 + 5或9位数字 + 可选符号 + 22位 → 取最后22位
 * - FedEx: 96 + 32位(总长34) → 取最后14位并去前导零
 * - 其他: 原样返回
 */

// USPS: 420 + 5或9位ZIP + 可选非数字符号 + 22位系统单号
const USPS_IDENTIFY = /^420(\d{5}|\d{9})\D*\d{22}$/;
const USPS_EXTRACT = /\d{22}$/;

// FedEx: 96 + 32位数字（总长34）→ 系统单号为最后14位去前导零
const FEDEX_IDENTIFY = /^96[0-9]{32}$/;
const FEDEX_EXTRACT = /\d{14}$/;

export function normalizeTrackingScan(rawScan: string): string {
    const raw = rawScan.trim();
    if (!raw) return rawScan;

    if (USPS_IDENTIFY.test(raw)) {
        const match = raw.match(USPS_EXTRACT);
        return match ? match[0] : raw;
    }

    if (FEDEX_IDENTIFY.test(raw)) {
        const match = raw.match(FEDEX_EXTRACT);
        if (!match) return raw;
        const trimmed = match[0].replace(/^0+/, '');
        return trimmed || '0';
    }

    return raw;
}
